import paymentHistoryCxpApi
  from "../api/paymentHistoryCxp.api";

const PaymentHistoryCxpService = {
  /**
   * 📄 Obtener historial de pagos
   * de una Cuenta por Pagar
   *
   * GET /api/payables/{id}/payment-history
   */
  getByPayableId: async (
    PayableId: number
  ) => {
    const response =
      await paymentHistoryCxpApi.fetchCustom(
        `/${PayableId}/payment-history`
      );

    return response.data;
  },
};

export default PaymentHistoryCxpService;